/* unplugin-vue-components disabled */import script from "./TaskList.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskList.vue?vue&type=script&setup=true&lang=js"

import "./TaskList.vue?vue&type=style&index=0&id=b6894574&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@5.8.3__webpack@5.99.8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6894574"]])

export default __exports__